import { CargoResponse } from '@state/types/MatchCargoToTerminalSimulations';
import { secureSplitApi } from './ref-api';

const segmentCargoApi = secureSplitApi.injectEndpoints({
  endpoints: (build) => ({
    fetchCargoBySegment: build.query<CargoResponse[], string>({
      query: (segment) => ({
        url: `segment/${segment}/cargo`,
        method: 'POST'
      })
    })
  }),
  overrideExisting: false
});

export const { useFetchCargoBySegmentQuery, useLazyFetchCargoBySegmentQuery } =
  segmentCargoApi;
